module.exports = __webpack_public_path__ + "img/heart.470bd2b9.svg";